"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var _ref$palette = _ref.palette,
    primary = _ref$palette.primary,
    text = _ref$palette.text,
    typography = _ref.typography,
    shade = _ref.utils.shade;
  return {
    root: {
      display: 'flex',
      padding: 0,
      margin: 0,
      listStyle: 'none',
      fontSize: 11,
      lineHeight: '15px',
      letterSpacing: '1.65px',
      textTransform: 'uppercase',
      fontWeight: typography.fontWeightSemiBold
    },
    item: {
      marginLeft: 5,
      color: primary.main,
      '&:first-child': {
        marginLeft: 0
      }
    },
    link: {
      color: '#1E8777',
      textDecoration: 'none'
    },
    icon: {
      marginLeft: 5,
      opacity: 0.5,
      color: text.primary
    }
  };
}, {
  name: 'Breadcrumbs'
});
exports.useStyles = useStyles;